import React, { Fragment, useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router';
import { useSnackbar } from 'notistack';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { read, utils, writeFileXLSX } from 'xlsx';
import { Paper, Button, Dialog, Grid, TextField, DialogActions, DialogContent, DialogTitle, Table, TableHead, TableBody, TableCell, CircularProgress, TableRow, Tabs, Tab, Tooltip } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { globalExportService, globalGetService, globalPostService } from '../../../utils_v2/globalApiServices';
import { checkApiStatus, downloadFileType, onCheckPermission } from '../../../utils_v2';
import { DropzoneArea } from 'material-ui-dropzone';
import AddIcon from '@material-ui/icons/Add';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
const ImportSpecsTemplate = ({ params, getResponseBack }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [tabIndex, setTabIndex] = useState(0);
    const [modal, setModal] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [importCrud, setImportCrud] = useState({ template: null });
    const [templates, setTemplates] = useState([])
    const [pres, setPres] = useState([]);
    const [error, setError] = useState([]);

    const getFormTemplates = () => {
        globalGetService(`technical/templates/?asset_type=${params.type}`, { type: 'T014' })
            .then(response => {
                if (checkApiStatus(response)) {
                    setTemplates(response.data.data.list)
                }
            })
    }
    const expectedFileHeaders = ['Category','Description','Value 1','Value 2','Value 1 Guidance Notes','Value 2 Guidance Notes','Source Document'];    
    const onChangeTemplate = (template) => {
        setImportCrud({ template });
        setLoading(true);
        if (template) {
            (async () => {
                const f = await (await fetch(template.file_path)).arrayBuffer();
                const wb = read(f); // parse the array buffer
                const ws = wb.Sheets['Specs']; // get the worksheet
                const data = utils.sheet_to_json(ws, { blankRows: false }); // generate objects
                const headers = Object.keys(data[0] || {});
                const validFile = expectedFileHeaders.some(header => headers.includes(header));
                if (!validFile) {
                    enqueueSnackbar('Unable to Import the file . Please check for exact column names as per sample template & data exists in the sheet', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' }, autoHideDuration: 9000});
                    setPres([]);
                    setLoading(false);
                    return;
                }
                const updatedData = data.map(row => ({
                    category: row['Category'] ? String(row['Category']) : '',
                    description: row['Description'] || '',
                    value_1: row['Value 1'] || '',
                    value_1_guidance_notes: row['Value 1 Guidance Notes'] || '',
                    value_2: row['Value 2'] || '',
                    value_2_guidance_notes: row['Value 2 Guidance Notes'] || '',
                    source_document: row['Source Document'] || '',

                }));
                setPres(updatedData); // update state
                setLoading(false);
            })();
        } else {
            setPres([]);
            setLoading(false);
        }
    }
    const handleFile =
        async (files) => {
            if (files.length === 0) return;
            setLoading(true);
            const file = files[0];
            const data = await file.arrayBuffer();
            const wb = read(data);
            const ws = wb.Sheets['Specs'];
            const jsonData = utils.sheet_to_json(ws, { blankRows: false });
            const headers = Object.keys(jsonData[0] || {});
            const validFile = expectedFileHeaders.some(header => headers.includes(header));
            if (!validFile) {
                enqueueSnackbar('Unable to Import the file . Please check for exact column names as per sample template & data exists in the sheet', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' }, autoHideDuration: 9000 });
                setPres([]);
                setLoading(false);
                return;
            }
            const updatedData = jsonData.map(row => ({
                category: row['Category'] ? String(row['Category']) : '',
                description: row['Description'] || '',
                value_1: row['Value 1'] || '',
                value_1_guidance_notes: row['Value 1 Guidance Notes'] || '',
                value_2: row['Value 2'] || '',
                value_2_guidance_notes: row['Value 2 Guidance Notes'] || '',
                source_document: row['Source Document'] || '',
            }));
            setPres(updatedData);
            setLoading(false)
    }
    const onFieldChange = (e, fieldName, value, index) => {
        setPres(prevPres => {
            const updatedPres = [...prevPres];
            updatedPres[index] = { ...updatedPres[index], [fieldName]: value };
            return updatedPres;
        });
    
        setError(prevError => {
            const updatedError = [...prevError];
            if (updatedError[index]) {
                updatedError[index] = { ...updatedError[index], [fieldName]: '' };
            }
            return updatedError;
        });
    };
    
    const onRemove = (index) => {
        setPres(pres.filter((item, itemIndex) => itemIndex !== index))
    }
    const onSetupTemplate = () => {
        let isValid = true, templateError=[];
        templateError = pres.map(item => {
          return {
            category: item.category && item.category.trim().length ? '':'Please enter category',
          }
        });
        templateError.map(data => {
            if(!Object.keys(data).every((k) => { return data[k] === ''})){
                isValid = false
            }
        });
        if(isValid){
        setLoading(true);
        globalPostService(`technical/workorder/${params.workOrderSlug}/t014/specs/?type=T014&asset_type=${params.type}`, { 'specs': pres })
            .then(response => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    getResponseBack();
                    setModal(false);
                    setImportCrud({ template: null });
                    setPres([]);
                } else {
                    enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                }
            })
        }else{
            setError(templateError)
        }
    }
    const downloadSampleTemplate = () => {     
        globalExportService(`technical/workorder/t014/sampleDownloadSpecs`)
        .then(response=>{
                downloadFileType(response, 'T014_Specs_Sample_Template.', 'xls' )
        })   
    }
    return (
        <Fragment>

            <Button onClick={() => { getFormTemplates(); setModal(true); setTabIndex(0)}} color='primary' variant='outlined' size='small'><AddIcon color='primary' style={{ fontSize: '1.15rem' }} />Import Template</Button>
            {modal ?
                <Dialog
                    open={modal}
                    onClose={() => { setModal(false) }}
                    className='project-modal'
                    maxWidth={false}
                >
                    <DialogTitle id="scroll-dialog-title">
                        Import Template
                    </DialogTitle>
                    <DialogContent dividers={true} style={{padding:'8px'}}>
                        <div style={{ width: '780px', minHeight: '400px' }}>
                            <Paper>
                                <Tabs
                                    value={tabIndex}
                                    onChange={(event, newValue) => { setPres([]); setTabIndex(newValue); setImportCrud({ template: null }) }}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    variant="fullWidth"
                                >
                                    <Tab label={<span>Custom Template</span>} />
                                    <Tab label={<span>Excel Import</span>} />
                                </Tabs>
                            </Paper>
                            {tabIndex === 0 ?
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={6}>
                                        <Autocomplete
                                            options={templates}
                                            getOptionLabel={option => option.name}
                                            id="template"
                                            value={importCrud.template}
                                            onChange={(e, value) => onChangeTemplate(value)}
                                            renderInput={params => <TextField required {...params} label="Select Template" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    </Grid>
                                    { onCheckPermission('project_management', 'template','C') ?
                                    <Grid item sm={6} style={{ padding: '20px 0px 0px 7px' }} >
                                        or &nbsp;
                                        <Link to='/technical/form/templates/'>
                                            <Button variant='contained' color='primary' ><AddIcon style={{ fontSize: '1.15rem', color:'#fff' }} />
                                                Add New Template
                                            </Button>
                                        </Link>
                                    </Grid>
                                    :null}
                                </Grid> :
                                <div>
                                    <div style={{Height:'280px'}}>
                                        {!pres.length ? <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                                            <span> Refer the sample template </span>
                                            <Button style={{ fontFamily: '"Conv_IBMPlexSans-Bold"', fontWeight: '700' }} size='small' color='primary' variant='text' aria-controls="simple-menu" aria-haspopup="true" onClick={downloadSampleTemplate} endIcon={<ArrowDropDownIcon fontSize='small' />}> Download </Button>
                                        </div> : null}
                                        {!pres.length ?
                                            <DropzoneArea
                                                acceptedFiles={['.xls, .xlsx,']}
                                                filesLimit={1}
                                                maxFileSize={104857600}
                                                showPreviewsInDropzone={false}
                                                useChipsForPreview={true}
                                                showPreviews={true}
                                                dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop Documents<br /> OR <br /> Click Here<br /> </p>}
                                                dropzoneClass="drag-drop-cnt"
                                                maxWidth="xl"
                                                showAlerts={['info', 'error']}
                                                alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                                clearOnUnmount={true}
                                                onChange={(files) => handleFile(files)}
                                            /> : null}
                                    </div>
                                    {!pres?.length ?<span  className='attachment-note' > Note : Supported extension ('.xls, .xlsx').</span>:null}
                                </div>
                            }
                            <Grid container spacing={1}>
                                {
                                    isLoading ?
                                        <Grid item sm={12}>
                                            <div style={{ textAlign: 'center', marginTop: '45px' }} >
                                                <CircularProgress size={40} />
                                            </div>
                                        </Grid> : null
                                }
                                <Grid item md={12}>
                                    {pres.length ?
                                        <Table className='mui-table-format'>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Category<sup>*</sup></TableCell>
                                                    <TableCell>Description</TableCell>
                                                    <TableCell>Value 1</TableCell>
                                                    <TableCell>Value 2</TableCell>
                                                    <TableCell>Source Document</TableCell>
                                                    <TableCell align="right">Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                { /* generate row for each president */
                                                    pres.map((pres, index) => (
                                                        <TableRow>
                                                            <TableCell>
                                                                <TextField
                                                                    name='category'
                                                                    id={`category_${index}`}
                                                                    value={pres?.category || ''}
                                                                    fullWidth
                                                                    style={{marginTop: '0px'}}
                                                                    margin="normal"
                                                                    onChange={(e) =>{ onFieldChange(e, 'category', e.target.value, index);}}
                                                                    variant='outlined'
                                                                    error={error && error[index] &&  error[index].category}
                                                                    helperText={error && error[index] &&  error[index].category}
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <TextField
                                                                    name='description'
                                                                    id={`description_${index}`}
                                                                    value={pres?.description || ''}
                                                                    fullWidth
                                                                    style={{marginTop: '0px'}}
                                                                    margin="normal"
                                                                    onChange={(e) => onFieldChange(e, 'description', e.target.value, index)}
                                                                    variant='outlined'
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <TextField
                                                                    name='value_1'
                                                                    id={`value_1_${index}`}
                                                                    value={pres?.value_1 || ''}
                                                                    fullWidth
                                                                    style={{marginTop: '0px'}}
                                                                    margin="normal"
                                                                    onChange={(e) => onFieldChange(e, 'value_1', e.target.value, index)}
                                                                    variant='outlined'
                                                                    placeholder={pres.value_1_guidance_notes}
                                                                />
                                                                 {/* <p style={{fontSize:'12px', color:'red'}}>{pres.value_1_guidance_notes}</p> */}
                                                            </TableCell>
                                                            <TableCell>
                                                                <TextField
                                                                    name='value_2'
                                                                    id={`value_2_${index}`}
                                                                    value={pres?.value_2 || ''}
                                                                    fullWidth
                                                                    style={{marginTop: '0px'}}
                                                                    margin="normal"
                                                                    onChange={(e) => onFieldChange(e, 'value_2', e.target.value, index)}
                                                                    variant='outlined'
                                                                    placeholder={pres.value_2_guidance_notes}
                                                                />
                                                                {/* <p style={{fontSize:'12px', color:'red'}}>{pres.value_2_guidance_notes}</p> */}
                                                            </TableCell>
                                                            <TableCell>
                                                                <TextField
                                                                    name='source_document'
                                                                    id={`source_document_${index}`}
                                                                    value={pres?.source_document || ''}
                                                                    fullWidth
                                                                    style={{marginTop: '0px'}}
                                                                    margin="normal"
                                                                    onChange={(e) => onFieldChange(e, 'source_document', e.target.value, index)}
                                                                    variant='outlined'
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                {pres.length !== 1 ?
                                                                    <Tooltip title='Delete' arrow><DeleteOutlineIcon color='secondary' onClick={() => onRemove(index)} style={{cursor:'pointer'}} /></Tooltip> : null
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table> : null
                                    }
                                </Grid>
                            </Grid>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={isLoading} onClick={() => { setModal(false);setPres([]);setImportCrud({template:null}) }} color="primary" size='small' variant='outlined'>Cancel</Button>
                        {pres.length ?
                            <Button disabled={isLoading} onClick={onSetupTemplate} color="primary" size='small' variant='contained'>
                                {isLoading ? <CircularProgress size={20} /> : 'Proceed'}
                            </Button> : null
                        }
                    </DialogActions>
                </Dialog> : null
            }
        </Fragment>
    )
}
export default withRouter(ImportSpecsTemplate);